/**
 * Design-space positions from map.svg `#giants` groups,
 * scaled SVG (2222×1263) → world (9960×5662).
 *
 * Single PNG per giant: idle === hover === group bbox.
 */
import type { GiantId } from '../../../../domain/ids/ids';

export type { GiantId };

export type GiantImagePlacement = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export type GiantPlacement = {
  id: GiantId;
  left: number;
  top: number;
  width: number;
  height: number;
  idle: GiantImagePlacement;
  hover: GiantImagePlacement;
};

function placement(
  id: GiantId,
  box: GiantImagePlacement,
): GiantPlacement {
  return {
    id,
    ...box,
    idle: box,
    hover: box,
  };
}

export const GIANT_PLACEMENTS: readonly GiantPlacement[] = [
  placement('sol', {
    left: 2796.626,
    top: 209.626,
    width: 644.356,
    height: 593.019,
  }),
  placement('mu', {
    left: 6708.208,
    top: 521.455,
    width: 387.777,
    height: 526.642,
  }),
  placement('serj', {
    left: 897.418,
    top: 1341.67,
    width: 1128.344,
    height: 1384.711,
  }),
  placement('mona', {
    left: 814.6,
    top: 2897.752,
    width: 1164.652,
    height: 663.005,
  }),
  placement('duck', {
    left: 911.394,
    top: 3895.241,
    width: 872.181,
    height: 784.36,
  }),
  placement('yetti', {
    left: 4965.918,
    top: 1843.318,
    width: 227.036,
    height: 293.837,
  }),
  placement('svami', {
    left: 3837.877,
    top: 2347.829,
    width: 560.57,
    height: 824.98,
  }),
  placement('roza', {
    left: 8378.727,
    top: 1501.64,
    width: 410.368,
    height: 339.68,
  }),
  placement('willy', {
    left: 6140.551,
    top: 3214.129,
    width: 1125.319,
    height: 725.243,
  }),
  placement('factor', {
    left: 4494.82,
    top: 4020.45,
    width: 948.889,
    height: 1037.065,
  }),
  placement('drakochi', {
    left: 7603.761,
    top: 4460.902,
    width: 314.264,
    height: 503.662,
  }),
] as const;
